// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1jNp8","name":"Header_name__1-pB1","birthday":"Header_birthday__2cNOR","skeleton":"Header_skeleton__1Va5v"};